import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

interface PropsRouteProps extends RouteProps {
  component: React.ComponentType
  isLoggedIn: boolean
}

const PrivateRoutes = ({ component: WrappedComponent, isLoggedIn, ...routeProps }: PropsRouteProps): React.ReactElement => {
  const comp = (props: any) => {
    return isLoggedIn ? (
      <WrappedComponent {...props} />
    ) : (
      <Redirect
        to={{
          pathname: '/auth/login',
          state: { from: props.location },
          search: `?redirect=${encodeURIComponent(location.pathname + location.search)}`
        }}
      />
    )
  }

  return <Route {...routeProps} render={comp} />
}

export default PrivateRoutes
